module.exports = __webpack_public_path__ + "static/media/google-play-badge.93051dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/google-play-badge.png
// module id = 620
// module chunks = 0